const THREE = window.THREE;

/**
 * Manages loading and access to all textures used by the 3D labels extension
 */
export const textureManager = {
    /**
     * Load all required textures
     * @returns {Object} Object containing all loaded textures
     */
    loadTextures() {
        const loadTexture = (url) => {
            const texture = THREE.ImageUtils.loadTexture(url);
            texture.minFilter = THREE.LinearFilter;
            return texture;
        };

        // Return map of textures (ONLY for 360 images and clusters)
        // All tag icons are now generated dynamically using shaders
        return {
            // 360 Image textures - still needed for image display
            cluster: loadTexture(require(`@/images/tags-icons/cluster.png`)),
            clusterHover: loadTexture(require(`@/images/tags-icons/cluster-hover.png`)),

            // 3D 360 images
            faro: loadTexture(require(`@/images/tags-icons/image360.png`)),
            faroHover: loadTexture(require(`@/images/tags-icons/image360-hover.png`)),
            leica: loadTexture(require(`@/images/tags-icons/image360.png`)),
            leicaHover: loadTexture(require(`@/images/tags-icons/image360-hover.png`)),
            gps: loadTexture(require(`@/images/tags-icons/image360.png`)),
            gpsHover: loadTexture(require(`@/images/tags-icons/image360-hover.png`)),
            geoslam: loadTexture(require(`@/images/tags-icons/image360.png`)),
            geoslamHover: loadTexture(require(`@/images/tags-icons/image360-hover.png`)),

            // 2D 360 images
            faro2d: loadTexture(require(`@/images/tags-icons/image360-2d.png`)),
            faro2dHover: loadTexture(require(`@/images/tags-icons/image360-2d-hover.png`)),
            leica2d: loadTexture(require(`@/images/tags-icons/image360-2d.png`)),
            leica2dHover: loadTexture(require(`@/images/tags-icons/image360-2d-hover.png`)),
            gps2d: loadTexture(require(`@/images/tags-icons/image360-2d.png`)),
            gps2dHover: loadTexture(require(`@/images/tags-icons/image360-2d-hover.png`)),
            geoslam2d: loadTexture(require(`@/images/tags-icons/image360-2d.png`)),
            geoslam2dHover: loadTexture(require(`@/images/tags-icons/image360-2d-hover.png`))
        };
    }
};
